import { createApiClient } from '@betstarters/api'

// Default client: talks only to bs-site-builder backend.
// All auth endpoints (/auth/login, /auth/refresh, /auth/me, /auth/logout) are
// proxied server-side to bs-iam via iamclient SDK.
const api = createApiClient({
  baseURL: `${import.meta.env.VITE_API_URL || ''}/api/v1`,
})

// IAM client: direct access to bs-iam for CRUD on IAM entities (sites, tenants, users).
// bs-site-builder uses these as "upstream" entities owned by bs-iam.
// Proxied in dev via /iam-api → http://localhost:8080.
export const iamApi = createApiClient({
  baseURL: `${import.meta.env.VITE_IAM_URL || '/iam-api'}/v1`,
})

export default api
